const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/**
 * Format an API timestamp like "2026-09-16 09:41:22" as "16 Sep 2026".
 *
 * Parsed by hand rather than with `new Date(value)`: a space instead of a "T"
 * is not part of the format the spec requires engines to accept, and Safari —
 * which is what the SuperApp WebView is on iOS — answers Invalid Date.
 * Returns null for anything unparseable, so callers can fall back to a dash.
 */
export const formatPlanDate = (value) => {
  if (!value || typeof value !== "string") return null;

  const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;

  const [, year, month, day] = match;
  const monthName = MONTHS[Number(month) - 1];
  if (!monthName) return null;

  return `${Number(day)} ${monthName} ${year}`;
};
